import { reactive } from 'vue';

export const useToastController = () => {
  const flow = {
    onDismiss: null,
    resolve: null,
    timeout: null
  }

  const state = reactive({
    isPresenting: false,
    data: null
  });

  const isPresenting = () => {
    return state.isPresenting;
  }

  const getData = () => {
    return state.data;
  }

  const getState = () => {
    return state;
  }

  const present = ({onDismiss = null, data = null, autoDismiss = 5000} = {}) => {
    if (state.isPresenting) {
      dismiss();
    }

    state.data = data;
    state.isPresenting = true;

    if (autoDismiss) {
      clearTimeout(flow.timeout);

      flow.timeout = setTimeout(() => {
        dismiss();
      }, autoDismiss);
    }

    if (!onDismiss) {
      flow.onDismiss = null;
      return new Promise((resolve, reject) => {
        flow.resolve = resolve;
      });
    } else {
      flow.onDismiss = onDismiss;
      flow.resolve = null;
    }
  }

  const dismiss = (result = null, data = null) => {
    state.isPresenting = false;

    if (flow.onDismiss) {
      flow.onDismiss({result, data});
    } else {
      flow.resolve({result, data});
    }
  }

  return {
    isPresenting,
    getData,
    present,
    dismiss,
    getState
  }
}
